import React, {useContext, useRef} from "react";
import {Button, Form, Input, Space, Typography} from "@bezlimit/bezlimit-ui";
import {useTranslation} from "react-i18next";
import {observer} from "mobx-react";
import _ from "lodash";
import "./style.scss";
// core
import {InterceptorContext, LayoutContext, ModalContext} from "../../../core/Contexts";
// hooks
import useFormHandler from "../../../core/hooks/useFormHandler";
import useOnCancel from "../../../core/hooks/useOnCancel";
// components
import Error from "../../modal/error";
// services
import ReservationsService from "../../../services/ReservationsService";

export default React.memo(
    observer(function RemoveEsimForm({id, tariffId, phone_number}: IProps) {
        const context = useContext(InterceptorContext);
        const contextLayout = useContext(LayoutContext);
        const contextModal = useContext(ModalContext);
        const ref = useRef(null);
        const {t} = useTranslation();
        const [form] = Form.useForm();
        const formInstance = useFormHandler(form);
        const onCancel = useOnCancel(formInstance);

        const onFinish = async () => {
            try {
                await ReservationsService.cancelReservationEsim(id);

                if (context?.setLoading) {
                    context?.setLoading(true);
                }
                window.location.reload();
            } catch (e: any) {
                contextModal?.setChildren(<Error />);
                if (context?.setLoading) {
                    context?.setLoading(true);
                }
            } finally {
                contextModal?.setOnCancel(() => onCancel);
                contextModal?.setVisible(false);
            }
        };

        return (
            <div ref={ref}>
                <Typography as="div" className="bl-remove-booking-form">
                    <Form
                        form={formInstance}
                        layout="horizontal"
                        name="extend"
                        onFinish={onFinish}
                        autoComplete="off"
                        initialValues={{
                            id
                        }}
                    >
                        <Form.Item noStyle name="id" hidden={true}>
                            <Input />
                        </Form.Item>

                        <Space
                            size={_.gte(contextLayout?.width ?? 0, 768) ? 16 : 8}
                            direction="horizontal"
                        >
                            <Typography
                                as="div"
                                className="text-center cancel"
                                size={14}
                                color="#000"
                            >
                                <Button type="text" onClick={onCancel} className="cancel-btn">
                                    {t("Закрыть")}
                                </Button>
                            </Typography>
                            <Form.Item shouldUpdate>
                                {() => {
                                    return (
                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                            loading={context?.loadingBtn}
                                            className="copy-btn"
                                        >
                                            {t("Подтверждаю")}
                                        </Button>
                                    );
                                }}
                            </Form.Item>
                        </Space>
                    </Form>
                </Typography>
            </div>
        );
    })
);

interface IProps {
    id: any;
    tariffId: string | undefined;
    phone_number: any;
}
